export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-10.png?9db3e4ecb6562148d7b43618a8e64f42";